import {CaptureExtensionUtils} from 'powtoon-commons/services/capture-extension'
export default CaptureExtensionUtils
